const groupBy = (list, keyGetter): Map<string, any> => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (collection === undefined) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

export { groupBy }
